<template>
  <div class="rank-container">
    <div class="page">
      <div class="filter">
        <el-form :model="formQuery" inline size="small">
          <div class="form-left">
            <el-form-item label="学生姓名">
              <el-input v-model="formQuery.stuName" clearable placeholder="请输入学生姓名"></el-input>
            </el-form-item>
            <el-form-item label="班级名称">
              <el-input v-model="formQuery.className" clearable placeholder="按班级名称精准搜索"></el-input>
            </el-form-item>
            <el-form-item v-if="teacherList.join('') !== ''" label="上课老师">
              <el-select v-model="formQuery.userId" style="width: 200px" clearable placeholder="请选择上课老师">
                <el-option v-for="item in teacherList" :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="methodSearch" v-if="$attrs.methodAuthTabView('查询')">查询</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="content">
        <div class="operation">
          <!-- <el-button type="primary" size="small" @click="freeDialog = true"
            >自由发放</el-button
          > -->
          <!-- <el-button style="margin-left: 20px" size="mini" type="primary" plain @click="getUserCampusList('1')">按班级发放</el-button> -->
          <!-- <el-button size="mini" type="primary" plain @click="getUserCampusList('2')">
            按学员发放</el-button> -->
          <el-button size="mini" type="primary" @click="methodDeductStarCoin(null)" v-if="$attrs.methodAuthTabView('批量操作')">
            星币批量操作</el-button>
        </div>
        <el-table size="small" :data="tableData" :header-cell-style="{
            background: '#f5f7fa',
            color: '#909399',
            'font-size': '14px',
          }" :header-row-style="{
            'border-radius': '5px',
            overflow: 'hidden',
          }" stripe @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column v-for="item in tableTitle" :key="item.value" :label="item.label" :prop="item.value" align="center" :width="item.width" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="item.value === 'index'">
                {{ scope.$index + 1 + (page.currentPage - 1) * page.pageSize }}
              </div>
              <div v-else-if="item.value === 'operation'">
                <!-- <el-button
                  type="text"
                  size="mini"
                  @click="methodShowRecord(scope.row)"
                >
                  查看详情
                </el-button> -->
                <el-button type="text" size="mini" @click="methodDeductStarCoin(scope.row)">
                  扣除/增加星币
                </el-button>
              </div>
              <div v-else>{{ scope.row[item.value] }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.currentPage" background :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </div>
      </div>

      <!-- 自由发放 -->
      <el-dialog title="自由发放选择" :visible.sync="freeDialog" width="500px">
        <div class="content">
          <el-form :model="freeDistribution" inline size="small">
            <!-- <el-form-item label="学生姓名"> -->
            <!-- <el-cascader
                v-model="freeDistribution.stuList"
                :options="stuList"
                :props="{ multiple: true }"
                clearable
                filterable
                @change="methodChangeStu"
              ></el-cascader> -->
            <!-- <selectLoadmore
                :disabled="false"
                :value="freeDistribution.stuList"
                :showList="stuList"
                valueName="label"
                @loadmore="loadmore"
                @remoteMethod="remoteMethod"
                @visibleChange="visibleChange"
                @change="change"
              >
              </selectLoadmore> -->
            <!-- <el-select
                v-model="freeDistribution.stuList"
                filterable
                remote
                placeholder="请输入关键词"
                :remote-method="fetchOptions"
                :loading="stuLoading"
              >
                <el-option
                  v-for="item in stuList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            <!-- </el-form-item> -->
            <el-form-item label="奖励数量">
              <el-input v-model="freeDistribution.num"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="medium" @click="methodConfirmFree">确 定</el-button>
          <el-button size="medium" @click="freeDialog = !freeDialog">取消</el-button>
        </span>
      </el-dialog>

      <!-- 星币获取记录 -->
      <el-dialog title="星币获取记录" :visible.sync="recordDialog" width="70%">
        <div class="record">
          <el-table size="small" :data="recordTableData" :header-cell-style="{
              background: '#f5f7fa',
              color: '#909399',
              'font-size': '14px',
            }" :header-row-style="{
              'border-radius': '5px',
              overflow: 'hidden',
            }" stripe>
            <!-- <el-table-column align="center" width="50" label="序号" fixed>
              <template slot-scope="scope">{{
                scope.$index + 1 + (page_no - 1) * page_size
              }}</template>
            </el-table-column> -->
            <el-table-column v-for="item in recordTableTitle" :key="item.value" :label="item.label" :prop="item.value" align="center" :width="item.width">
              <template slot-scope="scope">
                <div v-if="item.value === 'index'">
                  {{ scope.$index + 1 }}
                </div>
                <div v-if="item.value === 'type'">
                  {{ typeMap[scope.row[item.value]] }}
                </div>
                <!-- <div v-else-if="item.value === 'operation'">
                <el-button
                  type="text"
                  size="mini"
                  @click="methodShowRecord(scope.row)"
                >
                  查看详情
                </el-button>
              </div> -->
                <div v-else>{{ scope.row[item.value] }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>

      <!--按班级发放-->
      <el-dialog title="按班级发放" :visible.sync="classDialogShow" width="80%" top="5vh">
        <div class="header">
          <el-form class="form-style" :model="classForm" size="mini" :inline="true" required>
            <el-form-item label="科目" required>
              <el-select v-model="classForm.subject_id" placeholder="请选择" filterable>
                <el-option :label="item.name" :value="item.id" v-for="item of subjectList" :key="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="所属校区:" required>
              <el-select v-model="classForm.school_id">
                <el-option
                  v-for="(item, index) of schoolList"
                  :key="index"
                  :label="item.campusName"
                  :value="item.dept_id"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="班级名称:">
              <el-input style="width: 200px" v-model="classForm.classname" placeholder="请输入名称" clearable @keyup.enter.native="getExamClassListForPostExam"></el-input>
            </el-form-item>
            <el-form-item v-if="teacherList.join('') !== ''" label="上课老师:">
              <el-select v-model="stuForm.tchId" style="width: 200px" clearable @change="getExamClassListForPostExam">
                <el-option v-for="item in teacherList" :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button class="search_btn" type="primary" size="mini" icon="el-icon-search" @click="getExamClassListForPostExam">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-table class="questtable" height="60vh" ref="multipleTable" size="mini" :data="classList" tooltip-effect="dark" style="width: 100%" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe @selection-change="handleSelectionChange1">
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column align="left" label="班级名称">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.teaching_type == '1'">面授课</span>
                <span v-else-if="scope.row.teaching_type == '2'">直播课</span>
                <span v-else-if="scope.row.teaching_type == '3'">录播课</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="上课时间">
              <template slot-scope="scope">
                <span>{{ scope.row.week_str }} / {{ scope.row.time_str }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="班级人数" prop="stuNum">
            </el-table-column>
            <el-table-column align="left" label="上课老师" prop="lecturer_realname">
            </el-table-column>

            <el-table-column align="left" label="所属校区" prop="campun_name">
            </el-table-column>
          </el-table>
        </div>

        <div style="margin: 20px; text-align: right">
          <el-pagination class="pages" @current-change="handleCurrentChange1" :current-page.sync="classPage.currentPage" layout="total, prev, pager, next" :page-size="classPage.pageSize" :total="classPage.total"></el-pagination>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="classDialogShow = false">取 消</el-button>
          <el-button size="small" type="primary" @click="getStudentsByClass">确 定</el-button>
        </span>
      </el-dialog>

      <!--单学员添加学员-->
      <el-dialog title="单学员添加" :visible.sync="stuDialogShow" width="80%" top="5vh">
        <div class="header">
          <el-form class="form-style" :model="stuForm" size="mini" :inline="true">
            <!-- <el-form-item label="所属校区:">
              <el-select v-model="stuForm.school_id">
                <el-option
                  v-for="(item, index) of schoolList"
                  :key="index"
                  :label="item.campusName"
                  :value="item.dept_id"
                ></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="学员姓名:">
              <el-input style="width: 200px" v-model="stuForm.realname" placeholder="请输入名称" clearable @keyup.enter.native="getExamStuListForPostExam"></el-input>
            </el-form-item>

            <el-form-item label="学员状态:">
              <el-select v-model="stuForm.stu_state" placeholder="请选择" style="width: 150px" @change="getExamStuListForPostExam">
                <el-option label="全部" value=""></el-option>
                <el-option label="试听" value="1"></el-option>
                <el-option label="在读" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="teacherList.join('') !== ''" label="上课老师:">
              <el-select v-model="stuForm.tchId" style="width: 200px" clearable @change="getExamStuListForPostExam">
                <el-option v-for="item in teacherList" :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button class="search_btn" type="primary" size="mini" icon="el-icon-search" @click="getExamStuListForPostExam">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-table class="questtable" height="60vh" ref="questtable" size="mini" :data="stuForm.stulist" tooltip-effect="dark" style="width: 100%" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe @selection-change="handleSelectionChange2">
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column align="left" label="学员姓名" prop="studentUserInfo.realname">
            </el-table-column>

            <el-table-column align="left" label="学生账号" prop="name">
            </el-table-column>
            <el-table-column align="left" label="所属班级">
              <template slot-scope="scope">
                <span v-for="item of scope.row.stuClassArr" :key="item.id">
                  <span>{{ item.classInfo.name }}</span>
                  <br />
                </span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="所属校区" prop="campusName">
            </el-table-column>
          </el-table>
        </div>
        <div style="margin: 20px; text-align: right">
          <el-pagination class="pages" @current-change="handleCurrentChange2" :current-page.sync="stuPage.currentPage" layout="total, prev, pager, next" :page-size="stuPage.pageSize" :total="stuPage.total"></el-pagination>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="stuDialogShow = false">取 消</el-button>
          <el-button size="small" type="primary" @click="methodChooseStudent">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 扣除星币 -->
      <el-dialog :title="deductDialogTitle" :visible.sync="deductDialog" width="500px">
        <div class="deduct-dialog-container">
          <el-form ref="refDedectForm" :model="dedectForm" :rules="dedectFormRules" :step="1" step-strictly inline label-width="80px">
            <el-form-item label="星币数量" prop="num">
              <el-input-number v-model="dedectForm.num" :precision="0" size="small"></el-input-number>
              <span style="padding-left:10px;font-size:12px;color:#999">星币为负数时扣除星币，为正数时发放星币</span>
            </el-form-item>
            <el-form-item label="备注">
              <el-input type="textarea" :rows="4" v-model="dedectForm.reason" placeholder="请输入30字以内的备注信息" :maxlength="30" show-word-limit size="small"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="deductDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="methodConfirmDeduct">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
// 调用查询
import {
  api_schoolStuStarQueryList,
  api_schoolStarGrantGetStarRecord,
  api_schoolStarGrantActiveGrant,
  api_eduCampusSelectTchListByCampus,
  // api_schoolStarGrantGrant,
} from '@/api/javaApi'

import { getZoneSchoolSubjectList } from '@/api/community'

import {
  newList,
  getClassesList,
  // getExamClassListForPostExam,
  // getExamStuListForPostExam,
  getExamStuListByClassIdsForPostExam,
} from '@/api/educational'
// 自定义懒加载下拉查询
// import selectLoadmore from '@/components/selectLoadmore.vue'

export default {
  name: 'starCoinRanking',
  // components: { selectLoadmore },
  props: ['campusData'],
  data: () => ({
    subjectList: [],
    classDialogShow: false,
    classForm: {
      school_id: null,
      classname: '',
      subject_id: null,
      owned: false,
      tchId: '',
    },
    schoolList: [],
    classList: [],
    selectListStu: [], //准备的学员列表
    classPage: {
      currentPage: 1,
      pageSize: 10,
      total: 1,
    },
    selectList: [],
    stuDialogShow: false,
    stuForm: {
      school_id: null,
      realname: '',
      stu_state: null,
      stulist: [],
      owned: false,
      tchId: '',
    },
    stuPage: {
      currentPage: 1,
      pageSize: 10,
      total: 1,
    },
    /******************************************** */
    formQuery: {
      eduCampusId: null,
      stuName: '',
      className: '',
      userId: ''
    },
    typeList: [
      { label: '自由发放', value: 0 },
      { label: '上课', value: 1 },
    ],
    typeMap: {
      0: '上课',
      1: '自由发放',
    },
    teacherList: [], //教师列表
    stuList: [], // 学生列表
    stuLoading: false,
    // 搜索，远程，懒加载下拉相关数据
    querys: '', // 远程搜索输入的内容
    selectLoading: false, //select加载
    stopLoading: false, // 最后一次加载之后，不再加载
    stuPage2: {
      // 懒加载相关参数，这里代表从第一条数据开始加载，一次加载十项
      currentPage: 1,
      pageSize: 10,
    },

    stuMap: {},
    // 自由发放
    freeDistribution: {
      stuList: [],
      num: '',
    },
    freeDialog: false,
    recordDialog: false,
    tableTitle: [
      { label: '序号', value: 'index', width: 50 },
      { label: '学生姓名', value: 'stuName' },
      { label: '学生账号', value: 'stuAccount' },
      { label: '所属班级', value: 'className' },
      { label: '星币数量', value: 'starNum' },
      { label: '操作', value: 'operation' },
    ],
    tableData: [],
    recordTableTitle: [
      { label: '序号', value: 'index', width: 50 },
      { label: '姓名', value: 'stuName' },
      { label: '星币', value: 'starNum' },
      { label: '来源', value: 'sourceName' },
      { label: '场景', value: 'scene' },
      { label: '发放时间', value: 'grantTime' },
      // { label: '发放方式', value: 'type' },
      { label: '发放人', value: 'granter' },
    ],
    multipleSelection: [],
    recordTableData: [],
    page: {
      pageSize: 10,
      currentPage: 1,
      total: 1,
    },
    cliclItem: null,
    deductDialog: false,
    deductDialogTitle: '扣除/增加星币',
    dedectForm: {
      num: 1,
      reason: '',
    },
    dedectFormRules: {
      num: [
        { required: true, message: '请输入星币数量', trigger: 'blur' },
        // { min: 1, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
      ],
    },
  }),
  created() {
    if (this.$attrs.methodAuthTabView('查询').viewScope === 1) {
      this.classForm.tchId = this.$store.state.user.userInfo.id
      this.stuForm.tchId = this.$store.state.user.userInfo.id
    } else {
      this.eduCampusSelectTchListByCampus()
    }
    this.formQuery.eduCampusId = this.campusData[0]
    this.methodSearch()
    this.getZoneSchoolSubjectList()
  },
  methods: {
    methodChangeCampus() {
      this.methodSearch()
    },
    methodConfirmFree() {
      this.schoolStarGrantActiveGrant()
      this.freeDialog = false
      this.classDialogShow = false
      this.stuDialogShow = false
    },
    methodConfirmRecord() {
      this.recordDialog = false
    },
    methodShowRecord(row) {
      this.schoolStarGrantGetStarRecord(row)
      this.recordDialog = true
    },
    methodDeductStarCoin(row) {
      console.log(row)
      if (row) {
        this.deductDialogTitle = '扣除/增加星币'
        this.clickItem = row
      } else {
        this.deductDialogTitle = '星币批量操作'
        if (this.multipleSelection.length === 0) {
          return this.$message.error('请选择学员')
        }
        this.clickItem = null;
      }

      this.deductDialog = true
      this.dedectForm.num = 1
      this.dedectForm.reason = ''
    },
    methodConfirmDeduct() {
      this.$refs['refDedectForm'].validate((valid) => {
        if (valid) {
          this.schoolStarGrantGrant()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 扣除星币
    schoolStarGrantGrant() {
      let stuIdList = [];
      if (this.clickItem) {
        stuIdList = [this.clickItem.stuId]
      } else {
        this.multipleSelection.forEach(item => {
          stuIdList.push(item.stuId)
        })
      }
      console.log('stuIdList:', stuIdList)
      api_schoolStarGrantActiveGrant({
        eduCampusId: this.$store.state.user.selected_schools[0],
        stuIdList,
        starNum: this.dedectForm.num,
        remark: this.dedectForm.reason,
        type: this.dedectForm.num >= 0 ? 1 : -1,
      }).then(res => {
        console.log(res)
        this.$message.success('操作成功')
        this.deductDialog = false
        this.clickItem = null
        this.methodSearch()
      })
      // api_schoolStarGrantGrant({
      //   stuId: this.clickItem.stuId,
      //   eduCampusId: this.clickItem.eduCampusId,
      //   type: -1, // type：奖励方式（-1扣除，0上课，1自由发放，2考试，3课堂创作，4出勤）
      //   starNum: -this.dedectForm.num,
      //   remark: this.dedectForm.reason,
      // }).then(() => {
      //   this.deductDialog = false
      //   this.clickItem = null
      //   this.methodSearch()
      // })
    },
    // 切换页数
    handleSizeChange(size) {
      this.page.pageSize = size
      this.page.currentPage = 1
      this.methodSearch()
    },
    // 切换页码
    handleCurrentChange(page) {
      this.page.currentPage = page
      this.methodSearch()
    },
    // 查询
    methodSearch() {
      this.schoolStuStarQueryList()
    },
    // 重置查询参数
    resetQuery() {
      this.formQuery = {
        ...this.formQuery,
        ...{
          stuName: '',
          productName: '',
          productCategory: null,
          productState: null,
          time: null,
          orderNumber: '',
        },
      }
      this.tableData = []
    },
    // 查看星币排行列表
    schoolStuStarQueryList() {
      api_schoolStuStarQueryList({
        eduCampusId: this.formQuery.eduCampusId, // 校区Id
        stuName: this.formQuery.stuName, //学生姓名
        className: this.formQuery.className,
        userId: this.formQuery.userId,
        pageRequest: {
          // 页码信息
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
        },
      }).then((res) => {
        console.log(res)
        if (res.content) this.tableData = res.content
        this.page = {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
        }
      })
    },
    // 查看星币获取记录
    schoolStarGrantGetStarRecord(row) {
      this.recordTableData = []
      api_schoolStarGrantGetStarRecord({
        stuId: row.stuId,
        // eduCampusId: this.formQuery.eduCampusId,
      }).then((res) => {
        console.log(res)
        this.recordTableData = res
      })
    },
    // 发放星币
    schoolStarGrantActiveGrant() {
      let stuIdList = []
      this.freeDistribution.stuList.forEach((item) => {
        stuIdList.push(item.id)
      })
      api_schoolStarGrantActiveGrant({
        eduCampusId: this.formQuery.eduCampusId,
        stuIdList,
        starNum: this.freeDistribution.num,
        granter: this.$store.state.user.userInfo.realName,
      }).then((res) => {
        console.log(res)
        this.$message.success('您已经成功发放星币')
        this.freeDistribution.stuList = []
        this.freeDistribution.num = ''
        this.methodSearch()
      })
    },
    methodChangeStu(arr) {
      this.freeDistribution.stuList = arr.flat(Infinity)
    },

    /***************************************************************************************************1 */
    // 获取科目
    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log('校区科目')
        this.subjectList = res.subjectList
        this.classForm.subject_id = res.subjectList[0].id
      })
    },
    eduCampusSelectTchListByCampus() {
      api_eduCampusSelectTchListByCampus({
        eduCampusIdList: this.$store.state.user.selected_schools,
      }).then((res) => {
        this.teacherList = res
      })
    },
    // 获取校区
    getUserCampusList(cmd) {
      if (cmd == '1') {
        this.classDialogShow = true
      } else if (cmd == '2') {
        this.stuDialogShow = true
      }
      this.classForm.school_id = this.$store.state.user.selected_schools[0]
      if (cmd == '1') {
        this.getExamClassListForPostExam()
      } else if (cmd == '2') {
        this.getExamStuListForPostExam()
      }
    },

    //获得学员列表
    getExamStuListForPostExam() {
      newList({
        tchId: this.stuForm.tchId,
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        // campusId: this.stuForm.school_id,
        normal_state: this.stuForm.stu_state,
        realname: this.stuForm.realname,
        page_no: this.stuPage.currentPage,
        page_size: this.stuPage.pageSize,
      }).then((res) => {
        console.log('单学员添加-学员列表')
        console.log(res)
        this.stuForm.stulist = res.studentList
        this.stuPage.total = res.total
      })
    },
    // 按班级搜索学员
    getExamClassListForPostExam() {
      getClassesList({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        // campusId: this.classForm.school_id,
        subject_id: this.classForm.subject_id,
        // curriculumId: this.classForm.curriculum_id,
        className: this.classForm.classname,
        // isShowSelfClass: this.classForm.owned,
        // teachingType: this.classForm.teaching_type,
        page_no: this.classPage.currentPage,
        page_size: this.classPage.pageSize,
      }).then((res) => {
        console.log('班级学员')
        console.log(res)
        this.classList = res.class_list
        this.classPage.total = res.total
      })
    },
    handleSelectionChange1(val) {
      this.selectList = val
    },
    handleCurrentChange1(val) {
      this.classPage.currentPage = val
      this.getExamClassListForPostExam()
    },
    getStudentsByClass() {
      console.log('根据班级id组,查询学生列表')
      var class_ids = []
      for (let k = 0; k < this.selectList.length; k++) {
        class_ids.push(this.selectList[k].id)
      }

      console.log('班级id组')
      console.log(class_ids)

      getExamStuListByClassIdsForPostExam({
        classIds: JSON.stringify(class_ids),
      }).then((res) => {
        console.log('考试学员列表')
        if (res.studentList.join('') !== '') {
          const arr = this.unique(res.studentList)
          console.log(arr)
          this.freeDistribution.stuList = arr
          this.freeDialog = true
        } else {
          this.$message.warning('当前选中班级没有学生')
        }
      })
    },
    //数组对象去重
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    handleSelectionChange2(val) {
      this.selectListStu = val
      console.log('预选学员列表')
      console.log(this.selectListStu)
    },
    handleCurrentChange2(val) {
      this.stuPage.currentPage = val
      this.getExamStuListForPostExam()
    },
    methodChooseStudent() {
      // this.studentList = this.studentList.concat(this.selectListStu)

      // this.studentList = this.unique(this.studentList)
      if (this.selectListStu.join('') !== '') {
        const arr = this.unique(this.selectListStu)
        console.log(arr)
        this.freeDistribution.stuList = arr
        this.freeDialog = true
      } else {
        this.$message.warning('当前选中班级没有学生')
      }
      // this.stuDialogShow = false
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    }
  },
}
</script>
<style scoped lang="scss">
.rank-container {
  width: 100%;
  height: 100%;
  .page {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px 30px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px #f0f4f5;
    border-radius: 5px;
    border: 1px solid #f4f5f9;
    .filter {
      .el-form {
        display: flex;
        justify-content: space-between;
      }
    }
    .content {
      .pagination {
        display: flex;
        justify-content: flex-end;
        padding: 10px 0;
      }
      .operation {
        padding-bottom: 15px;
      }
    }
  }
  .deduct-dialog-container {
    .el-form {
      .el-form-item /deep/ {
        display: flex;
        .el-form-item__label {
          flex-shrink: 0;
        }
        .el-form-item__content {
          width: 100%;
        }
      }
    }
  }
}
</style>
